<div class="email-login__container">
  <!-- The component uses this div to launch the firebaseui library -->
  <div id="firebaseui-auth-container">
  </div>

  @if (accountService.authError) {
    <mat-card class="email-login__error-message">
      Something went wrong. Please refresh the page to try signing in again. If the issue persists, please contact support.
    </mat-card>
  }
</div>

